<template>
  <div style="min-height: 80vh">

    <div class="card bg-light shadow-sm" style="background: #fff;margin-top: 10px;border-radius: 15px">
      <div class="card-body collapsible cursor-pointer rotate"
           style="background: #fff;border-radius: 15px;">
        <div>
          <div class="d-flex align-items-center">
<!--            <el-select v-model="value" class="store_openingHours" placeholder="全部门店" size="mini" style="margin-left: 10px"-->
<!--                       @change="storeChange">-->
<!--              <el-option-->
<!--                  v-for="item in options"-->
<!--                  :key="item.id"-->
<!--                  :label="item.storeName"-->
<!--                  :value="item.id">-->
<!--              </el-option>-->
<!--            </el-select>-->
            <div style="display: flex;align-items: center;margin-left: 16px">
              <div style="margin-right: 10px">
                订单编号:
              </div>
              <div>
                <el-input v-model="queryParams.orderNo" size="mini" :controls="false" clearable style="width: 130px" placeholder="请输入订单编号"/>
              </div>
            </div>
            <div style="display: flex;align-items: center;margin-left: 16px">
              <div style="margin-right: 10px">
                收益时间:
              </div>
              <div>
                <el-date-picker
                    v-model="searchDataRange"
                    size="mini"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    clearable
                    align="right">
                </el-date-picker>
              </div>
            </div>
            <div style="display: flex;align-items: center;margin-left: 16px">
              <div style="margin-right: 10px">
                类型:
              </div>
              <el-select v-model="queryParams.type" class="store_openingHours" placeholder="全部类型" size="mini"
                         style="margin-left: 10px"
                         clearable>
                <el-option label="套餐/团购" value="1"></el-option>
                <el-option label="挂单" value="2"></el-option>
                <el-option label="退款" value="5"></el-option>
                <el-option label="提现" value="-1"></el-option>
              </el-select>
            </div>
            <div style="display: flex;align-items: center;margin-left: 16px">
              <div style="margin-right: 10px">
                是否冻结:
              </div>
              <el-select v-model="queryParams.isFreeze" class="store_openingHours" placeholder="全部" size="mini"
                         style="margin-left: 10px;width: 80px"
                         clearable>
                <el-option label="是" value="true"></el-option>
                <el-option label="否" value="false"></el-option>
              </el-select>
            </div>
            <div>
              <div style="display: flex;align-items: center">
                <div style="margin-right: 10px">
                  是否提现:
                </div>
                <el-select v-model="queryParams.isWithdraw" class="store_openingHours" placeholder="全部" size="mini"
                           style="margin-left: 10px;width: 130px"
                           clearable>
                  <el-option label="已提现" value="true"></el-option>
                  <el-option label="待提现" value="false"></el-option>
                </el-select>
              </div>
            </div>
            <div class="d-flex align-items-center" style="margin-left: 10px">
              <el-button @click="searchOverview" type="primary" size="small" round>查询</el-button>
              <el-button @click="resetSearchOverview" size="small" round>重置</el-button>
              <!--              <a class="btn btn-link" style="margin-left: 10px"-->
              <!--                 id="kt_horizontal_search_advanced_link"-->
              <!--                 data-bs-toggle="collapse"-->
              <!--                 href="#overview_search_form"-->
              <!--              >-->
              <!--                高级查询-->
              <!--              </a>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-column flex-row-fluid gap-7 gap-lg-10" style="border-radius: 15px;margin-top: 10px">
      <div class="tab-content">
        <div class="tab-pane fade show active">
          <div class="d-flex flex-column gap-7 gap-lg-10">
            <div class="card" style="border-radius:15px">

              <div class="card-body" style="padding-top: 4px;">
                <div style="margin-top: 0;min-height: 54vh">
                  <div class="table-responsive">
                    <table id="kt_ecommerce_products_table"
                           class="table align-middle table-row-dashed table-hover fs-6 gy-5 dataTable no-footer"
                    >
                      <thead>
                      <tr class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                        <th class="text-center">
                          订单编号
                        </th>
                        <th>类型
                        </th>
                        <th>
                          收益时间
                        </th>
                        <th>
                          销售额
                        </th>
                        <th>
                          <el-tooltip class="item" effect="dark"
                                      content="该部分金额由平台进行结算，请前往提现流水中进行提现" placement="top-start">
                            <div>金额
                              <el-icon class="el-icon-question"></el-icon>
                            </div>
                          </el-tooltip>
                        </th>
                        <th>门店
                        </th>
                        <th class="text-center">
                          操作
                        </th>
                      </tr>
                      </thead>
                      <tbody class="fw-semibold text-gray-600">
                      <tr v-for="(item,index) in rows" :key="index">
                        <td style="font-size: 10px;" class="text-center">
                          {{ item.orderNo === '-1' ? '' : item.orderNo }}
                        </td>
                        <td>
                          {{ item.typeStr }}
                        </td>
                        <td>
                          {{ item.createTime }}
                        </td>
                        <td>
                          {{ item.salePrice | format }}
                        </td>
                        <td v-if="item.type === 4 || item.type === 5">
                          {{ item.settlingPrice * -1 | format }}
                        </td>
                        <td v-else>
                          {{ item.settlingPrice | format }}
                        </td>
                        <td>
                          {{ item.storeName }}
                        </td>
                        <td class="text-center" style="width: 200px">
                          <el-link type="primary" v-if="item.orderNo !== -1" @click="gotoOrder(item)">明细</el-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                  </div>

                </div>
                <div style="display: flex;justify-content: right">
                  <paginations :limit.sync="queryParams.size" :page.sync="queryParams.current" :total="total"
                               @pagination="getPage"></paginations>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
import {mixins} from "@/views/Finance/components/income/mixins";
import Paginations from "@/components/Paginations/index.vue";

export default {
  components: {Paginations},
  mixins: [mixins],
}
</script>
